<template>
  <div class="container">
    <div id="canvasBox" :style="getHorizontalStyle">
      <div class="greet">
        <flexbox>
          <flexbox-item>
            <x-button
              type="danger"
              style="width: 100px;color: #000;"
              @click.native="clear"
              >清屏</x-button
            >
          </flexbox-item>
          <flexbox-item>
            <x-button
              type="primary"
              style="width: 100px;"
              @click.native="showConfirm = true"
              >上传</x-button
            >
          </flexbox-item>
        </flexbox>
      </div>
      <canvas></canvas>
    </div>
    <confirm
      v-model="showConfirm"
      :close-on-confirm="false"
      title="提示"
      @on-confirm="upload"
    >
      <p style="text-align:center;">确定签字上传?</p>
    </confirm>
  </div>
</template>

<script>
import Draw from "@/utils/draw";

import { buildSignAction, signUpload } from "../../api/frame";
import { Flexbox, FlexboxItem } from "vux";
import { getClientDetail } from "@/api/client";

export default {
  data() {
    return {
      msg: "请在下方空白处签名",
      degree: 90,
      signImage: null,
      showConfirm: false,
      signVisible: false,
      fileId: "",
      params: {
        file: "",
        c: "",
        clientId: ""
      },
      userInfo: ""
    };
  },
  components: {
    Flexbox,
    FlexboxItem
  },
  beforeCreate() {
    document.title = "手写签名";
  },
  activated() {
    this.getUserInfo();
    this.getSignAction();
  },
  mounted() {
    this.fileId = this.$route.query.fileId;
    this.canvasBox = document.getElementById("canvasBox");
    this.initCanvas();
  },
  computed: {
    getHorizontalStyle() {
      const d = document;
      const w =
        window.innerWidth ||
        d.documentElement.clientWidth ||
        d.body.clientWidth;
      const h =
        window.innerHeight ||
        d.documentElement.clientHeight ||
        d.body.clientHeight;
      let length = (h - w) / 2;
      let width = w;
      let height = h;

      switch (this.degree) {
        case -90:
          length = -length;
          break;
        case 90:
          width = h;
          height = w;
          break;
        default:
          length = 0;
      }
      if (this.canvasBox) {
        this.canvasBox.removeChild(document.querySelector("canvas"));
        this.canvasBox.appendChild(document.createElement("canvas"));
        // eslint-disable-next-line vue/no-async-in-computed-properties
        setTimeout(() => {
          this.initCanvas();
        }, 200);
      }
      return {
        transform: `rotate(${this.degree}deg) translate(${length}px,${length}px)`,
        width: `${width}px`,
        height: `${height}px`,
        transformOrigin: "center center"
      };
    }
  },
  methods: {
    getUserInfo() {
      getClientDetail()
        .then(res => {
          this.params.clientId = res.id;
        })
        .catch(err => {
          this.$showError(err);
        });
    },
    getSignAction() {
      buildSignAction({ code: "oilFrameworkProtocol" })
        .then(res => {
          this.params.c = res.c;
        })
        .catch(err => {
          this.$showError(err);
        });
    },
    initCanvas() {
      const canvas = document.querySelector("canvas");
      this.draw = new Draw(canvas, -this.degree);
    },
    clear() {
      this.draw.clear();
    },
    upload() {
      this.$vux.loading.show({
        transition: "",
        text: "处理中"
      });
      this.showConfirm = false;
      const form = new FormData();
      const image = this.draw.getPNGImage();
      const blob = this.draw.dataURLtoBlob(image);
      form.append("clientId", this.params.clientId);
      form.append("c", this.params.c);
      form.append("file", blob);
      signUpload(form)
        .then(() => {
          this.$vux.loading.hide();
          this.$router.replace({ path: "/user/frameShow" });
        })
        .catch(err => {
          this.$vux.loading.hide();
          this.$showError(err);
        });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
}
#canvasBox {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.greet {
  padding: 20px;
  font-size: 20px;
  user-select: none;
}
input {
  font-size: 20px;
}
.greet select {
  font-size: 18px;
}
canvas {
  flex: 1;
  cursor: crosshair;
  border: 2px dashed lightgray;
}
.image-box {
  width: 100%;
  height: 100%;
}
.image-box header {
  font-size: 18px;
}
.image-box img {
  max-width: 80%;
  max-height: 80%;
  margin-top: 50px;
  border: 1px solid gray;
}
</style>
